import React from 'react';

const OnerikLogoMedium = ({ size = 'md' }) => {
  const sizes = {
    sm: 'w-16 h-16',
    md: 'w-24 h-24',
    lg: 'w-32 h-32',
    xl: 'w-40 h-40',
    '2xl': 'w-28 h-28'
  };

  return (
    <div className={`relative flex items-center justify-center ${sizes[size]}`}>
      <svg 
        width="100%" 
        height="100%" 
        viewBox="0 0 200 200" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient id="logoGradientMed" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#1e3a8a" stopOpacity="1" />
            <stop offset="50%" stopColor="#0f172a" stopOpacity="1" />
            <stop offset="100%" stopColor="#000000" stopOpacity="1" />
          </radialGradient>
          <linearGradient id="ringGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#a855f7" />
            <stop offset="100%" stopColor="#3b82f6" />
          </linearGradient>
          <filter id="glowMed">
            <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
        
        {/* Outer circle */}
        <circle 
          cx="100" 
          cy="100" 
          r="90" 
          fill="url(#logoGradientMed)"
          stroke="url(#ringGradient)"
          strokeWidth="2"
          filter="url(#glowMed)"
        />
        
        {/* Orbital rings */}
        <ellipse 
          cx="100" 
          cy="100" 
          rx="70" 
          ry="30" 
          fill="none"
          stroke="url(#ringGradient)"
          strokeWidth="1.5"
          opacity="0.7"
          transform="rotate(45 100 100)"
        />
        <ellipse 
          cx="100" 
          cy="100" 
          rx="70" 
          ry="30" 
          fill="none"
          stroke="url(#ringGradient)"
          strokeWidth="1.5"
          opacity="0.7"
          transform="rotate(-45 100 100)"
        />
        
        {/* Center glow */}
        <circle 
          cx="100" 
          cy="100" 
          r="15" 
          fill="#a855f7"
          opacity="0.8"
        />
        <circle 
          cx="100" 
          cy="100" 
          r="8" 
          fill="#c4b5fd"
        />
      </svg>
    </div>
  );
};

export default OnerikLogoMedium;
